// ══════════════════════════════════════════════
//  区域定价 - 国家字典与工具
//  规则：国内固定 CNY 不参与区域定价；海外统一 USD，可按国家码覆盖售价
//  价格单位：分（与真实接口一致）
//  TODO: 联调时国家字典替换为接口数据
// ══════════════════════════════════════════════

// 国家/地区字典（复用全球调度/设备区域国家，海外区域定价使用）
export const COUNTRY_OPTIONS = [
    { value: 'US', label: '美国' },
    { value: 'CA', label: '加拿大' },
    { value: 'MX', label: '墨西哥' },
    { value: 'BR', label: '巴西' },
    { value: 'AR', label: '阿根廷' },
    { value: 'CL', label: '智利' },
    { value: 'CO', label: '哥伦比亚' },
    { value: 'PE', label: '秘鲁' },
    { value: 'GB', label: '英国' },
    { value: 'IE', label: '爱尔兰' },
    { value: 'FR', label: '法国' },
    { value: 'DE', label: '德国' },
    { value: 'IT', label: '意大利' },
    { value: 'ES', label: '西班牙' },
    { value: 'PT', label: '葡萄牙' },
    { value: 'NL', label: '荷兰' },
    { value: 'BE', label: '比利时' },
    { value: 'LU', label: '卢森堡' },
    { value: 'CH', label: '瑞士' },
    { value: 'AT', label: '奥地利' },
    { value: 'SE', label: '瑞典' },
    { value: 'NO', label: '挪威' },
    { value: 'DK', label: '丹麦' },
    { value: 'FI', label: '芬兰' },
    { value: 'IS', label: '冰岛' },
    { value: 'PL', label: '波兰' },
    { value: 'CZ', label: '捷克' },
    { value: 'SK', label: '斯洛伐克' },
    { value: 'HU', label: '匈牙利' },
    { value: 'RO', label: '罗马尼亚' },
    { value: 'BG', label: '保加利亚' },
    { value: 'GR', label: '希腊' },
    { value: 'HR', label: '克罗地亚' },
    { value: 'RS', label: '塞尔维亚' },
    { value: 'UA', label: '乌克兰' },
    { value: 'RU', label: '俄罗斯' },
    { value: 'TR', label: '土耳其' },
    { value: 'JP', label: '日本' },
    { value: 'KR', label: '韩国' },
    { value: 'TW', label: '中国台湾' },
    { value: 'HK', label: '中国香港' },
    { value: 'MO', label: '中国澳门' },
    { value: 'SG', label: '新加坡' },
    { value: 'MY', label: '马来西亚' },
    { value: 'TH', label: '泰国' },
    { value: 'VN', label: '越南' },
    { value: 'ID', label: '印度尼西亚' },
    { value: 'PH', label: '菲律宾' },
    { value: 'IN', label: '印度' },
    { value: 'PK', label: '巴基斯坦' },
    { value: 'BD', label: '孟加拉国' },
    { value: 'LK', label: '斯里兰卡' },
    { value: 'KH', label: '柬埔寨' },
    { value: 'MM', label: '缅甸' },
    { value: 'MN', label: '蒙古' },
    { value: 'KZ', label: '哈萨克斯坦' },
    { value: 'AE', label: '阿联酋' },
    { value: 'SA', label: '沙特阿拉伯' },
    { value: 'IL', label: '以色列' },
    { value: 'QA', label: '卡塔尔' },
    { value: 'KW', label: '科威特' },
    { value: 'AU', label: '澳大利亚' },
    { value: 'NZ', label: '新西兰' },
    { value: 'ZA', label: '南非' },
    { value: 'EG', label: '埃及' },
    { value: 'NG', label: '尼日利亚' },
    { value: 'KE', label: '肯尼亚' },
    { value: 'MA', label: '摩洛哥' },
    { value: 'GH', label: '加纳' },
    { value: 'TZ', label: '坦桑尼亚' },
];

export const getCountryLabel = (code) => COUNTRY_OPTIONS.find(c => c.value === code)?.label || code || '-';

// 分 → 元（表单展示用）
export const fenToYuan = (v) => (v === undefined || v === null ? undefined : Number((v / 100).toFixed(2)));
// 元 → 分（提交接口用）
export const yuanToFen = (v) => (v === undefined || v === null || v === '' ? undefined : Math.round(Number(v) * 100));

// 分 → 美元展示，如 95 → $0.95
export const formatUsdFen = (fen) => (fen === undefined || fen === null ? '-' : `$${(fen / 100).toFixed(2)}`);
// 分 → 人民币展示，如 690 → ¥6.90
export const formatCnyFen = (fen) => (fen === undefined || fen === null ? '-' : `¥${(fen / 100).toFixed(2)}`);

// 区域定价摘要，如「海外默认 $0.95 · 2 国覆盖」
export const regionPricingSummary = (regionPricing) => {
    if (!regionPricing || regionPricing.defaultUsd === undefined || regionPricing.defaultUsd === null) return '';
    const countryCount = (regionPricing.countryOverrides || []).filter(c => c && c.country).length;
    return `海外默认 ${formatUsdFen(regionPricing.defaultUsd)}${countryCount ? ` · ${countryCount} 国覆盖` : ''}`;
};

// 区域定价是否为有效配置（有海外默认价或国家覆盖）
export const hasRegionPricing = (regionPricing) =>
    !!regionPricing && ((regionPricing.defaultUsd !== undefined && regionPricing.defaultUsd !== null)
        || (regionPricing.countryOverrides || []).some(c => c && c.country));
